// extracted by mini-css-extract-plugin
export default {"btnStyle":"Button_btnStyle__HfzTx"};